module.exports = __webpack_public_path__ + "img/right-carousel.4c25d18b.svg";